<template>
  <div>
    <el-button type="primary" class="preparation" @click="clickPreparation">料金マスタ準備</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data () {
    return {}
  },
  methods: {
    // clickClear () {
    //   // console.log('SearchDialogFooter.clickClear(S)')
    //   this.$emit('clear')
    //   // console.log(this)
    //   // console.log('SearchDialogFooter.clickClear(E)')
    // },
    clickPreparation () {
      this.$emit('preparation')
    }
  }
}
</script>

<style lang="scss" scoped>
.preparation {
  width: 10em;
}
</style>
